// Imported before Turbo so local history can be handled before its popstate listener.
window.addEventListener("popstate", event => {
  const restore = new CustomEvent("schedule-days:restore", {cancelable: true})
  window.dispatchEvent(restore)
  if (restore.defaultPrevented) event.stopImmediatePropagation()
})
